/**
 * Convenience class for easier and more error safe handling with URLs.
 */
export class Url {
    /// available prefixes to be used for a URL
    private prefixes = {
        ssl: 'https://',
        standard: 'http://',
        socket: 'ws://',
    };

    private prefix: string;

    /// contains all elements of a URL
    private routes: string[] = [];

    constructor(prefix: string, url_string: string = null) {
        if (prefix !== null && prefix !== undefined) {
            this.routes.push(this.prefixes[prefix]);
        }

        if (url_string !== null) {
            const segments = url_string.split('/');
            for (const piece of segments) {
                this.routes.push(piece);
            }
        }
    }

    /**
     * Adds a new route to the URL.
     */
    push(next: string): void {
        if (next[next.length - 1] === '/') {
            this.routes.push(next.slice(0, next.length - 1));
            return;
        }
        this.routes.push(next);
    }

    /**
     * Converts the URL to a machine readable URL string.
     */
    toString(): string {
        let output = '';
        if (this.prefix !== null && this.prefix !== undefined) {
            output += this.prefix;
        }
        for (let i = 0; i < this.routes.length; ++i) {
            if (i === 0) {
                output += this.routes[i];
            } else {
                output += '/' + this.routes[i];
            }
        }

        return output;
    }
}
